import { Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

import { Loading } from 'components';

import userAuthenticationStore from 'stores/authentication-store';

import authenticationService from 'services/authentication/authentication-service';

function ProtectedPageWrapper({ children }) {
  const isAuthenticated = userAuthenticationStore((state) => state.isAuthenticated);
  const setAuthenticated = userAuthenticationStore((state) => state.setAuthenticated);
  const setUserInfo = userAuthenticationStore((state) => state.setUserInfo);

  const [loadingMeData, setLoadingMeData] = useState(true);

  useEffect(() => {
    async function fetchMeData() {
      let userInfo = null;

      try {
        userInfo = await authenticationService.getMyInfo();
      } catch(e) {
        console.error(e);
      }

      if (userInfo && userInfo.id) {
        setAuthenticated(true);
        setUserInfo(userInfo);
      } else {
        setAuthenticated(false);
        setUserInfo(null);
      }

      setLoadingMeData(false);
    }

    if (!isAuthenticated) {
      setLoadingMeData(true);
      fetchMeData()
    }
  }, []);

  if (isAuthenticated) {
    return children;
  }

  if (loadingMeData) {
    return (
      <Loading />
    )
  } else if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  } else {
    return children;
  }
};

export default ProtectedPageWrapper;